import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const OpenDialogBox = ({ open, onClose, onDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">Are you sure you want to delete this?</DialogTitle>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton type="button" onClick={handleDelete} loading={isDeleting}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

OpenDialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default OpenDialogBox;
